import { create } from 'zustand';
// Decode a JWT's payload without verifying (client is untrusted by the API
// anyway — we just need the impersonation claim to drive the banner on load).
function decodeJwt(token) {
    if (!token)
        return null;
    try {
        const parts = token.split('.');
        if (parts.length < 2)
            return null;
        const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(json);
    }
    catch {
        return null;
    }
}
function hydrateUser() {
    const raw = JSON.parse(localStorage.getItem('koggelman_user') || 'null');
    if (!raw)
        return null;
    // Overlay impersonation claims from the current access token so the banner
    // shows up immediately after a page reload.
    const claims = decodeJwt(localStorage.getItem('koggelman_access_token'));
    if (claims?.impersonatedBy) {
        return {
            ...raw,
            impersonatedBy: claims.impersonatedBy,
            impersonatedByEmail: claims.impersonatedByEmail,
            impersonatedByDisplayName: claims.impersonatedByDisplayName,
        };
    }
    return raw;
}
export const useAuthStore = create((set) => ({
    user: hydrateUser(),
    accessToken: localStorage.getItem('koggelman_access_token'),
    refreshToken: localStorage.getItem('koggelman_refresh_token'),
    isAuthenticated: !!localStorage.getItem('koggelman_access_token') || !!localStorage.getItem('koggelman_refresh_token'),
    setAuth: (user, accessToken, refreshToken) => {
        localStorage.setItem('koggelman_user', JSON.stringify(user));
        localStorage.setItem('koggelman_access_token', accessToken);
        localStorage.setItem('koggelman_refresh_token', refreshToken);
        // Pick up impersonation claims from the new token so the banner reflects
        // state immediately (without a full page reload).
        const claims = decodeJwt(accessToken);
        const userWithClaims = claims?.impersonatedBy
            ? {
                ...user,
                impersonatedBy: claims.impersonatedBy,
                impersonatedByEmail: claims.impersonatedByEmail,
                impersonatedByDisplayName: claims.impersonatedByDisplayName,
            }
            : user;
        set({ user: userWithClaims, accessToken, refreshToken, isAuthenticated: true });
    },
    logout: () => {
        localStorage.removeItem('koggelman_user');
        localStorage.removeItem('koggelman_access_token');
        localStorage.removeItem('koggelman_refresh_token');
        localStorage.removeItem('koggelman_impersonator_email');
        localStorage.removeItem('koggelman_impersonator_name');
        set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false });
    },
}));
